<template>
  <div id="app">
    <router-view v-if="!chatIsChecking && !wishlistIsChecking && virtualTourData" />
    <Loader v-if="appIsFetching" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loader from '@/components/Loader'

const log = require('bows')('App.vue', '[FE]')

export default {
  name: 'app',
  components: { Loader },
  computed: {
    ...mapGetters(['appIsFetching', 'chatIsChecking', 'wishlistIsChecking', 'virtualTourData', 'tourFeatures'])
  },
  methods: {
    ...mapActions({
      verifyWishlistLocalStorage: 'WISHLIST_CHECK_LOCAL_STORAGE_VERSION',
      verifyChatLocalStorage: 'CHAT_CHECK_LOCAL_STORAGE_VERSION',
      initialiseIntroPopupShown: 'INIT_INTRO_POPUP_SHOWN'
    })
  },
  created() {
    this.initialiseIntroPopupShown()
    Promise.all([this.verifyWishlistLocalStorage(), this.verifyChatLocalStorage()]).then(results => {
      if (!results[0]) {
        log('Incorrect local storage for wishlist')
      }
      if (!results[1]) {
        log('Incorrect local storage for chat')
      }
    })
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Work+Sans:wght@200;300;400&display=swap');
@import '~bootstrap/scss/bootstrap-grid.scss';

input {
  box-shadow: none !important;
}

img {
  -webkit-user-drag: none;
}

// Images fit cover

.img-fit {
  width: auto;
  height: 100%;
  object-fit: cover;
  object-position: center;
  @include media-breakpoint-up(lg) {
    width: 100%;
    height: auto;
  }
}

// Swiper pagination override

.swiper-pagination {
  .swiper-pagination-bullet {
    opacity: 1;
    background-color: white;
    border: 1px solid #fff;
    box-shadow: 0px 0px 5px #000;
    @include media-breakpoint-up(lg) {
      height: 14px;
      width: 14px;
    }
    @include media-breakpoint-down(md) {
      border-width: 2px;
      height: 12px;
      width: 12px;
    }
  }
  .swiper-pagination-bullet-active {
    opacity: 1;
    background-color: black;
    border: 1px solid #fff;
    box-shadow: 0px 0px 5px #000;
    @include media-breakpoint-up(lg) {
      height: 16px;
      width: 16px;
    }
    @include media-breakpoint-down(md) {
      height: 12px;
      width: 12px;
    }
  }
}
.swiper-button-disabled {
  display: none !important;
}
.swiper-button-prev,
.swiper-button-next {
  color: #fff !important;
  text-shadow: 0px 0px 5px #000;
}

// Bootstrap color override
.bg-dark {
  background-color: black !important;
}

.bg-light {
  background-color: #f5f5f5 !important;
}

// Modal Common Style
.modal-backdrop {
  background: rgba(0, 0, 0, 0.5);
  opacity: 1;
}
.modal-content {
  border-radius: 0;
}

.btn {
  border-radius: 0;

  &.btn-dark {
    background: #000 !important;
  }
}

.modal-content {
  border-radius: 0;
  border: none;
}

/* remove the outline effect around links on Chrome */
*:focus {
  outline: none !important;
  outline-style: none !important;
  box-shadow: none !important;
  border-color: transparent;
}
.text-truncated {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.square-container {
  position: relative;
}
.square-container:after {
  content: '';
  display: block;
  padding-bottom: 100%;
}
.square-content {
  position: absolute;
  width: 100%;
  height: 100%;
}

html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: 'Ubuntu';
}

#virtual-tour {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
